import { IMarkerModelMap } from "@directives/_map/angularGoogleMaps/uiGmapMarkers.component";
import { IVeriMapChildComponent, IVeriMapComponent, MapPopupType } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IGoogleMapsMarker } from "@interfaces/IGoogleMapsMarkerOptions";
import { IVehicle } from "@interfaces/IVehicle";
import { CanvasService, IPieDataSeries } from "@services/canvas.service";
import { GoogleMarkerService } from "@services/googleMarker.service";
import { MapService } from "@services/map.service";
import { PlotService } from "@services/plot.service";
import { VehicleService } from "@services/vehicle.service";
import * as angular from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";
import { ClusterIcon, IMarkerOptions, NgMapCluster } from "@typings/google.maps.angular";

export interface IUtilisationMetrics {
    numUtilised: number;
    numNotUtilised: number;
    utilisationPercentage: number;
}

interface IVeriMapVehiclesBindings {

    veriMap: IVeriMapComponent;

    vehicleClicked(vehicle: { $vehicle: IVehicle });
    vehicleRightClicked(vehicle: { $vehicle: IVehicle });

    vehicleMouseOver(vehicle: { $vehicle: IVehicle, $event: Event });
    vehicleMouseOut(vehicle: { $vehicle: IVehicle });

    clusterMouseOver(ngMapCluster: { $ngMapCluster: NgMapCluster, $metrics: IUtilisationMetrics });
    clusterMouseOut(ngMapCluster: { $ngMapCluster: NgMapCluster, $metrics: IUtilisationMetrics });

    vehicles: IVehicle[];
    selectedVehicle: IVehicle;

    fit: boolean;
    showPlotTime: boolean;
    disableClustering: boolean;
    showOutOfBoundsIndicator: boolean;
}

class VeriMapVehiclesComponentController implements angular.IComponentController, IVeriMapVehiclesBindings, IVeriMapChildComponent {
    veriMap: IVeriMapComponent;

    vehicleClicked: (vehicle: { $vehicle: IVehicle }) => void;
    vehicleRightClicked: (vehicle: { $vehicle: IVehicle }) => void;

    vehicleMouseOver: (vehicle: { $vehicle: IVehicle, $event: Event }) => void;
    vehicleMouseOut: (vehicle: { $vehicle: IVehicle }) => void;

    clusterMouseOver: (ngMapCluster: { $ngMapCluster: NgMapCluster, $metrics: IUtilisationMetrics }) => void;
    clusterMouseOut: (ngMapCluster: { $ngMapCluster: NgMapCluster, $metrics: IUtilisationMetrics }) => void;

    vehicles: IVehicle[] = [];
    displayMarkers: IGoogleMapsMarker<IVehicle>[] = [];
    selectedVehicle: IVehicle;

    fit: boolean;
    showPlotTime: boolean = false;
    disableClustering: boolean = false;
    showOutOfBoundsIndicator: boolean = false; // prototype functionality

    vehicleMarkerOptions: IMarkerOptions<IVehicle> = {
        events: {},
        control: {},
        type: "cluster",
        typeOptions: {
            imagePath: "https://rawgit.com/googlemaps/js-marker-clusterer/gh-pages/images/m",
            maxZoom: 13,
            gridSize: 40 // default 60
        },
        typeEvents: {}
    };

    // Might want to put this into veriMap rather than keep it here
    hasFitMap = false;

    static $inject = ["$scope", "$q", "vehicleService", "googleMarkerService", "plotService", "mapService", "canvasService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $q: angular.IQService,
        private readonly vehicleService: VehicleService,
        private readonly googleMarkerService: GoogleMarkerService,
        private readonly plotService: PlotService,
        private readonly mapService: MapService,
        private readonly canvasService: CanvasService) {
    }

    $onInit(): void {
        this.vehicleMarkerOptions.type = (this.disableClustering) ? "" : "cluster";

        this.vehicleMarkerOptions.events.click = (markerObj: google.maps.Marker, eventName: string, clickedVehicle: IVehicle/*, args: any[]*/) => {

            if (this.vehicleClicked != null) {
                this.vehicleClicked({ $vehicle: clickedVehicle["model"] });
            }
        }

        this.vehicleMarkerOptions.events.rightclick = (markerObj: google.maps.Marker, eventName: string, clickedVehicle: IVehicle/*, args: any[]*/) => {
            if (this.vehicleRightClicked != null) {
                this.vehicleRightClicked({ $vehicle: clickedVehicle });
            }
        }

        this.vehicleMarkerOptions.events.mouseover = (marker, eventName, clickedVehicle, mouseEvent) => {
            this.onVehicleMouseOver(marker, clickedVehicle as any, mouseEvent);
            this.stopEventPropogation(mouseEvent);
            mouseEvent.cancelBubble = true;
        };

        this.vehicleMarkerOptions.events.mouseout = (marker, eventName, clickedVehicle) => { this.onVehicleMouseOut(marker, clickedVehicle as any); };

        this.vehicleMarkerOptions.typeEvents.postClusterShow = (clusterIcon) => { this.clusteringFunction(clusterIcon); }
        this.vehicleMarkerOptions.typeEvents.click = (markers, models) => { this.onClusterClick(markers, models); };
        this.vehicleMarkerOptions.typeEvents.mouseover = (ngMapCluster) => { this.onClusterMouseOver(ngMapCluster); };
        this.vehicleMarkerOptions.typeEvents.mouseout = (ngMapCluster) => { this.onClusterMouseOut(ngMapCluster); };
        
        this.vehicleMarkerOptions.typeOptions.maxZoom = this.veriMap.userOptions.Clustering.Value ? 12 : 1;

        this.veriMap.registerChildComponent(this);
    }

    $onDestroy() {
        this.veriMap.deregisterChildComponent(this);
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["vehicles"]) {
            this.onVehiclesUpdated();
        }

        if (onChangesObj["selectedVehicle"]) {

            // If we are a trailer, then we should actually select the tractor
            if (this.selectedVehicle && this.selectedVehicle.tractor) {

                var foundTractor = this.vehicleService.findVehicle(this.vehicles, this.selectedVehicle.tractor.Id);
                if (foundTractor) {
                    this.selectedVehicle = foundTractor;
                }
            }

            this.updateSelectedVehicleStatus();
        }

        //if (onChangesObj["updateTrigger"]) {
        //    //console.log("update trigger");
        //    this.onVehiclesUpdated();
        //}
    }

    modelMap: IMarkerModelMap[] = [];

    onMarkersUpdated(modelMap: IMarkerModelMap[]) {
        this.modelMap = modelMap;

        //if (this.selectedVehicle) {
        //    modelMap.forEach(map => {
        //        console.log(map, this.selectedVehicle.Id);
        //        if (map.id == this.selectedVehicle.Id) {
        //            console.log("selected vehicle", map);
        //        }
        //    });
        //}

        // Set to true to track vehicle
        this.updateSelectedVehicleStatus(false);
    }

    // --------------------------

    private stopEventPropogation(event: any) {
        if (event.length > 0) {
            event = event[0];
        }

        //var methods = Object.getOwnPropertyNames(Object.getPrototypeOf(event)).filter(m => 'function' === typeof event[m])

        event.cancelBubble = true;

        if (event.stop) {
            event.stop();
        }

        if (event.stopPropagation) {
            event.stopPropagation();
        }

        if (event.preventDefault) {
            event.preventDefault();
        }
        else {
            event.returnValue = false;
        }
    }

    private showVehicleOnMap(vehicle: IVehicle): boolean {
        return !vehicle.tractor || vehicle === this.selectedVehicle;
    }

    private onVehiclesUpdated() {
        var promiseList: angular.IPromise<any>[] = [];

        if (this.vehicles) {
            for (var i = 0; i < this.vehicles.length; i++) {
                const vehicle = this.vehicles[i];

                // Trailers are shown underneath tractors, so we shouldnt show them on here
                if (!this.showVehicleOnMap(vehicle) || !vehicle.Plot) {
                    continue;
                }

                const isSelected = this.selectedVehicle && this.selectedVehicle.Id == vehicle.Id;

                var promise = this.googleMarkerService.generateGoogleMapsMarkerOptionsForVehicle(vehicle, isSelected, this.showPlotTime).then(options => {

                    vehicle.Plot.markerModel = {
                        id: vehicle.Plot.Id,
                        options: options
                    };
                });

                promiseList.push(promise);
            };
        }

        this.$q.all(promiseList).then(() => {

            this.displayMarkers = [];

            for (var i = 0; i < this.vehicles.length; i++) {
                const vehicle = this.vehicles[i];

                if (this.showVehicleOnMap(vehicle) && vehicle.Plot) {
                    var markerModel: IGoogleMapsMarker<IVehicle> = copy(vehicle.Plot.markerModel);
                    markerModel.model = vehicle;

                    this.displayMarkers.push(markerModel);
                }
            };
        });

        // Add remove vehicles from display list

        //console.time("onVehiclesUpdated");
        //var promiseList: angular.IPromise<any>[] = [];

        //this.vehicles.forEach(v => {
        //    var shouldDisplay = this.showVehicleOnMap(v) && v.Plot;
        //    if (!shouldDisplay) {
        //        return;
        //    }

        //    var currentlyDisplayed = this.vehicleService.findVehicle(this.displayVehicles, v.Id);
        //    if (shouldDisplay && !currentlyDisplayed) {
        //        this.displayVehicles.push(v);
        //    }

        //    const isSelected = this.selectedVehicle && this.selectedVehicle.Id == v.Id;
        //    var promise = this.googleMarkerService.generateGoogleMapsMarkerOptionsForVehicle(v, isSelected).then(options => {
        //        v.Plot.options = options;
        //    });

        //    promiseList.push(promise);
        //});

        //this.$q.all(promiseList).then(() => {

        //    this.displayVehicles = this.displayVehicles.slice();

        //    console.timeEnd("onVehiclesUpdated");
        //    console.log(this.displayVehicles.length);
        //});


        //if (this.vehicles) {
        //    for (var i = 0; i < this.vehicles.length; i++) {
        //        const vehicle = this.vehicles[i];

        //        // Trailers are shown underneath tractors, so we shouldnt show them on here
        //        if (!this.showVehicleOnMap(vehicle) || !vehicle.Plot) {
        //            continue;
        //        }

        //        const isSelected = this.selectedVehicle && this.selectedVehicle.Id == vehicle.Id;
        //        var promise = this.googleMarkerService.generateGoogleMapsMarkerOptionsForVehicle(vehicle, isSelected).then(options => {
        //            vehicle.Plot.options = options;
        //        });

        //        promiseList.push(promise);
        //    };
        //}

        //this.$q.all(promiseList).then(() => {

        //    this.displayVehicles = [];

        //    for (var i = 0; i < this.vehicles.length; i++) {
        //        const vehicle = this.vehicles[i];

        //        if (this.showVehicleOnMap(vehicle) && vehicle.Plot) {
        //            this.displayVehicles.push(vehicle);
        //        }
        //    };

        //    //this.displayVehicles = this.vehicles.slice();
        //    console.timeEnd("onVehiclesUpdated");
        //});

        this.fitMap();
    }

    getLatLngsForFitMap(): google.maps.LatLng[] {

        const latLngs: google.maps.LatLng[] = [];

        if (this.selectedVehicle) {
            this.addVehicleLatestPlot(this.selectedVehicle, latLngs);
        }
        else if (this.vehicles) {
            this.vehicles.forEach(vehicle => {
                this.addVehicleLatestPlot(vehicle, latLngs);
            });
        }

        return latLngs;
    }

    private addVehicleLatestPlot(vehicle: IVehicle, latLngs: google.maps.LatLng[]) {
        var latestPlot = vehicle.Plot;
        if (latestPlot && latestPlot.Latitude && latestPlot.Longitude) {
            const latLng = new google.maps.LatLng(latestPlot.Latitude, latestPlot.Longitude);
            latLngs.push(latLng);
        }
    }

    private getMarkerModel(id: number): IMarkerModelMap {

        for (var i = 0; i < this.modelMap.length; i++) {
            const map = this.modelMap[i];
            if (map.id == id) {
                return map
            }
        }

        return null;
    }

    private updateSelectedVehicleStatus(forceFitMap = true) {

        if (!this.veriMap.mapInitialised) {
            this.veriMap.mapInitialisedPromise.then(() => {
                this.updateSelectedVehicleStatus(forceFitMap);
            });

            return;
        }

        if (!this.vehicles) {
            return;
        }

        this.vehicles.forEach(v => {

            const marker = this.getMarkerModel(v.Id);

            if (!marker) {
                return;
            }

            var selected = v == this.selectedVehicle;
            var markerLabel = (marker.googleMarker as any);
            var wasSelected = markerLabel.labelClass.indexOf("selected") >= 0;

            // No change, do nothing
            if (selected == wasSelected) {
                return;
            }

            this.googleMarkerService.generateGoogleMapsMarkerOptionsForVehicle(v, selected, this.showPlotTime).then(newOptions => {
                if (!marker.googleMarker) {
                    return;
                }

                if (selected) {
                    markerLabel.labelClass = markerLabel.labelClass + " selected";
                }
                else {
                    markerLabel.labelClass = markerLabel.labelClass.replace("selected", "");
                }

                marker.googleMarker.setOpacity(selected || !this.selectedVehicle ? 1 : 0.5);
                marker.googleMarker.setZIndex(selected ? 100 : 1);
                marker.googleMarker.setIcon(newOptions.icon);
            });
        });

        if (this.selectedVehicle && this.shouldFitMap(forceFitMap) && this.selectedVehicle.Plot) {
            var fast = navigator.hardwareConcurrency >= 6;
            fast = false; // permanently disable for now

            //if (fast) {
            //    this.mapService.smoothPanAndZoomTo(this.veriMap.getMap(), new google.maps.LatLng(vehicle.Plot.Latitude, vehicle.Plot.Longitude), 13);
            //}
            //else {
            if (this.veriMap.getMap().getZoom() < 13) {
                this.veriMap.getMap().setZoom(13);
                this.veriMap.panMap(new google.maps.LatLng(this.selectedVehicle.Plot.Latitude, this.selectedVehicle.Plot.Longitude));
                // Smooth pan and zoom ONLY if zooming is required, otherwise just snap
                //this.mapService.smoothPanAndZoomTo(this.veriMap.getMap(), new google.maps.LatLng(vehicle.Plot.Latitude, vehicle.Plot.Longitude), 13);
            }
            else {
                this.veriMap.panMap(new google.maps.LatLng(this.selectedVehicle.Plot.Latitude, this.selectedVehicle.Plot.Longitude));
            }
            //}

            this.hasFitMap = true;
        }
        else {
            //this.hasFitMap = false;
            //this.fitMap();
        }
    }

    private shouldFitMap(force = false) {
        if (force) {
            this.hasFitMap = false;
        }

        return this.fit && !this.hasFitMap && this.vehicles.length !== 0;
    }

    private fitMap() {
        if (!this.shouldFitMap()) {
            return;
        }

        var latLngs = this.getLatLngsForFitMap();
        this.hasFitMap = latLngs.length > 0;

        if (this.hasFitMap) {
            this.veriMap.fitMap(latLngs);
        }
    }

    private onClusterClick(markers: google.maps.Marker[], models: any[]) {

        this.veriMap.hidePopup(MapPopupType.Cluster, true);

        this.$scope.$applyAsync();
    }

    private onClusterMouseOver(ngMapCluster: NgMapCluster) {
        // CJE disabling cluster popups...TRIAL...

        //if (this.clusterMouseOver) {
        //    var utilisationMetrics = this.calculateClusterUtilisation(ngMapCluster.clusterIcon_)
        //    var position = this.mapService.applyOffsetToLatLng(this.veriMap.getMap(), ngMapCluster.center_, new google.maps.Point(0, -30));

        //    this.clusterMouseOver({ $ngMapCluster: ngMapCluster, $metrics: utilisationMetrics });
        //    this.veriMap.showPopup(MapPopupType.Cluster, position, utilisationMetrics);

        //    this.$scope.$applyAsync();
        //}
    }

    private onClusterMouseOut(ngMapCluster: NgMapCluster) {
        if (this.clusterMouseOut) {
            //var utilisationMetrics = this.calculateClusterUtilisation(ngMapCluster.clusterIcon_)

            //this.clusterMouseOut({ $ngMapCluster: ngMapCluster, $metrics: utilisationMetrics });
            //this.updateClusterSelectionStatus(ngMapCluster.clusterIcon_);
            this.$scope.$applyAsync();
        }

        this.veriMap.hidePopup(MapPopupType.Cluster, false);
    }

    private onVehicleMouseOver(marker: google.maps.Marker, vehicle: IGoogleMapsMarker<IVehicle>, mouseEvent?: Event) {

        if (this.vehicleMouseOver) {
            this.vehicleMouseOver({ $vehicle: vehicle.model, $event: mouseEvent });
        }

        mouseEvent.cancelBubble = true;
    }

    private onVehicleMouseOut(marker: google.maps.Marker, vehicle: IGoogleMapsMarker<IVehicle>) {
        if (this.vehicleMouseOut) {
            this.vehicleMouseOut({ $vehicle: vehicle.model });
        }
    }

    clusteringFunction(clusterIcon: ClusterIcon) {
        if (this.disableClustering) {
            return;
        }

        if (!clusterIcon.div_) {
            return;
        }

        const utilisationColorRaw = this.plotService.getUtilisationColor(true);
        const nonUtilisationColorRaw = this.plotService.getUtilisationColor(false);

        const utilisation = this.calculateClusterUtilisation(clusterIcon);

        var data: IPieDataSeries[] = [];
        data.push({
            color: utilisationColorRaw,
            value: utilisation.numUtilised
        });

        data.push({
            color: nonUtilisationColorRaw,
            value: utilisation.numNotUtilised
        });

        var pieCanvas = this.canvasService.getPieCanvas(clusterIcon.width_, data);
        clusterIcon.div_.appendChild(pieCanvas);

        this.updateClusterSelectionStatus(clusterIcon);
    }

    updateClusterSelectionStatus(clusterIcon: ClusterIcon) {

        if (!clusterIcon.div_ || !clusterIcon.visible_) {
            return;
        }

        const currentImageString = clusterIcon.url_.substr(clusterIcon.url_.lastIndexOf("/") + 1, 2);

        clusterIcon.div_.className = `cluster ${currentImageString}`;

        // Check for selected status
        for (let i = 0; i < clusterIcon.cluster_.markers_.length; i++) {
            const marker = clusterIcon.cluster_.markers_[i];

            if (marker.model.model.Plot.selected) {
                clusterIcon.div_.className += " selected";
                break;
            }
        }
    }

    private calculateClusterUtilisation(clusterIcon: ClusterIcon): IUtilisationMetrics {
        var vehicleUtilisisationCount = 0;
        var vehicleUnderUtilisisationCount = 0;

        const markers = clusterIcon.cluster_.markers_;

        markers.forEach(marker => {

            if (this.plotService.isPlotUtilised(marker.model.model.Plot.Reason)) {
                vehicleUtilisisationCount++;
            }
            else {
                vehicleUnderUtilisisationCount++;
            }
        });

        const utilisationPercentage = Math.round(vehicleUtilisisationCount * 100 / markers.length);

        return {
            numUtilised: vehicleUtilisisationCount,
            numNotUtilised: vehicleUnderUtilisisationCount,
            utilisationPercentage: utilisationPercentage
        };
    }
}

export class VeriMapVehiclesComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {

            vehicles: "<",
            selectedVehicle: "<",
            updateTrigger: "<",

            vehicleClicked: "&",
            vehicleRightClicked: "&",

            vehicleMouseOver: "&",
            vehicleMouseOut: "&",

            clusterMouseOver: "&",
            clusterMouseOut: "&",

            fit: "@",
            showPlotTime: "<?",
            disableClustering: "<?",
            showOutOfBoundsIndicator: "<?"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = VeriMapVehiclesComponentController;
        this.template = require("./veriMapVehicles.html");
    }
}
